/**
 * @property {Sprite} sprite
 * @property {Scene} scene
 * @property {System} system
 */
export default class Brain {

	constructor(args) {
		this.entity = null;
		this.sprite = null;
		this.scene = null;
		this.system = null;
		this.behaviours = [];
		if(args && args.behaviours) this.behaviours = args.behaviours;
	}

	init(entity) {
		this.entity = entity;
		this.sprite = entity.sprite;
		this.scene = entity.scene;
		this.system = entity.system;
		for(let b of this.behaviours) {
			b.init(this);
		}
	}
	
	update(delta, deltaNormal) {
		// I am a Brain and I am having a think
		for(let b of this.behaviours) {
			b.update(delta, deltaNormal);
		}
	}

	destroy() {
		// https://www.youtube.com/watch?v=l3JupHh7zvo
		this.behaviours = [];
	}

}